const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

/**
 * Validation functions intended to work with formik and react-i18next libraries
 */

export const validateCheckbox = (
  checked: boolean,
  { required = true } = {},
): string | undefined => {
  if (!checked && required) {
    return "errors.forms.checkbox";
  }
};

export const validateEmail = (
  values: Record<string, any>,
  { required = true } = {},
): string | undefined => {
  const { email } = values;

  if (!email && required) {
    return "errors.forms.email.missing";
  } else if (!emailRegex.test(email)) {
    return "errors.forms.email.invalid";
  }
};

export const validatePresent = (
  key: string,
  values: Record<string, any>,
): string | undefined => {
  if (!values[key]) return "errors.forms.input";
};

export const validateNumeric = (
  key: string,
  values: Record<string, any>,
): string | undefined => {
  if (values[key] && /\D/.test(values[key])) {
    return `errors.forms.${key}.invalid`;
  }
};

export const validateZip = (
  key: string,
  values: Record<string, any>,
  { required = false } = {},
): string | undefined => {
  const validatedPresent = validatePresent(key, values);
  if (required && validatedPresent) {
    return validatedPresent;
  }

  if (values[key] && !/^\d{5}(-\d{4})?$/.test(values[key])) {
    return `errors.forms.${key}.invalid`;
  }
};
